import NumberBox from "devextreme-react/number-box";
import ScrollView from "devextreme-react/scroll-view";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { AddKhoanNopModalRespone } from "..";
import { bomApi } from "../../../api/bomApi";
import { bomChiTietApi } from "../../../api/bomChiTietApi";
import { hinhThucNopBomApi } from "../../../api/hinhThucNopBom";
import { mucPhaiThuChiTietApi } from "../../../api/mucPhaiThuChiTietApi";
import { localStorageHelper } from '../../../helpers/localStorage';
import { showNotify } from "../../../helpers/toast";
import { sf_bom } from "../../../models/response/bom/sf_bom";
import { sf_bom_chitiet_viewmodel } from "../../../models/response/bom/sf_bom_chitiet";
import { sf_hinhthucnopbom } from "../../../models/response/category/sf_hinhthucnopbom";
import { XIcon, CheckIcon, ChevronRightIcon, ChevronUpIcon } from "@primer/octicons-react";
import { Box, Checkbox, IconButton } from "@primer/react";
import Button from "../../../components/ui/button";
import ModalActions from "../../../components/ui/modal/ModalActions";
import DataGrid from "../../../components/data-grid";
import { IDataGridColumn } from "../../../components/data-grid/type/IDataGridProps";
import TextInput from "../../../components/ui/text-input";
import Text from "../../../components/ui/text";
import TextWithEllipse from "../../../components/ui/text-with-ellipse";
import { PlaceHolder } from "../../place-holder";
import { formatVND } from "../../../utils/formatVND";
import SelectBoxMultipleKhomKhoanNop from "../../selectbox-nhomkhoannop/SelectBoxMultipleKhomKhoanNop";
import { useSelector } from "react-redux";
import { RootState } from "../../../state/reducers";

type AddKhoanNopFromBomProps = {
    sf_bom_id: number,
    sf_khoannop_ids_added?: number[],
    onSelected: (data: AddKhoanNopModalRespone) => void,
    onCancel: () => void,
    isSaving: boolean,
    ts_hocsinh_id: number
}
export const AddKhoanNopFromBom = (props: AddKhoanNopFromBomProps) => {
    const { sf_nhomkhoannops } = useSelector((state: RootState) => state.nhomKhoanNop);
    const [sf_bom, set_sf_bom] = useState<sf_bom>();
    const [sf_bom_chitiet_viewmodels, set_sf_bom_chitiet_viewmodels] = useState<any[]>([])
    const [sf_bom_chitiet_selected_ids, set_sf_bom_chitiet_selected_ids] = useState<number[]>([])
    const [sf_hinhthucnopboms, set_sf_hinhthucnopboms] = useState<sf_hinhthucnopbom[]>([])
    const [is_tinh_mien_giam, set_is_tinh_mien_giam] = useState<boolean>(true)
    const [isShowPlaceHolder, SetIsShowPlaceHolder] = useState<boolean>(true)
    const [khoanDaNops, setKhoanDaNops] = useState<number[]>([]);
    const [summary, setSummary] = useState<number>();
    const [expandedGroups, setExpandedGroups] = useState<Map<string, string>>(new Map());
    const [selectedNhomKhoanNopIds, setSelectedNhomKhoanNopIds] = useState<number[]>([]);
    const [selectedNhomKhoanNopNames, setSelectedNhomKhoanNopNames] = useState<string[]>([]);

    useEffect(() => {
        handleReloadBom();
    }, [])
    useEffect(() => {
        if (sf_bom) {
            handleReloadHinhThucNopBom();
            handleReloadBomChiTiets();
        }
    }, [sf_bom]);
    useEffect(() => {
        const new_sf_bom_chitiets = ConfigSoTienApDung(sf_bom_chitiet_selected_ids, undefined);
        set_sf_bom_chitiet_viewmodels(new_sf_bom_chitiets);
    }, [sf_bom_chitiet_selected_ids]);

    useEffect(() => {
        const filterData = sf_bom_chitiet_viewmodels.filter((x: any) => khoanDaNops === undefined || !khoanDaNops.includes(x.sf_khoannop_id));
        set_sf_bom_chitiet_viewmodels(filterData)
    }, [khoanDaNops])

    const raw_data_source = useMemo(() => {
        let sf_khoannops: any[] = [];
        for (var i = 0; i < sf_bom_chitiet_viewmodels.length; i++) {
            const sf_bom_chitiet = sf_bom_chitiet_viewmodels[i];
            if (sf_khoannops.find(sf_khoannop => sf_khoannop.id === sf_bom_chitiet.sf_khoannop_id) === undefined) {
                sf_khoannops.push({
                    id: sf_bom_chitiet.sf_khoannop_id,
                    ma_khoan_nop: sf_bom_chitiet.ma_khoan_nop,
                    ma_khoan_nop_group: sf_bom_chitiet.ma_khoan_nop_group,
                    ten_khoan_nop_group: sf_bom_chitiet.ten_khoan_nop_group,
                    ten_khoan_nop: sf_bom_chitiet.ten_khoan_nop
                })
            }
        }
        sf_khoannops = sf_khoannops.filter(x => x.id > 0);
        const result = sf_khoannops.map(sf_khoannop => {
            let item: any = { ...sf_khoannop, so_tien: 0, so_tien_phai_nop: 0 }
            sf_hinhthucnopboms.forEach(sf_hinhthucnopbom => {
                const sf_bom_chitiet = sf_bom_chitiet_viewmodels.find(x => x.sf_khoannop_id === sf_khoannop.id
                    && x.sf_hinhthucnopbom_id === sf_hinhthucnopbom.id);
                if (sf_bom_chitiet) {
                    item[`T_${sf_hinhthucnopbom.id}`] = sf_bom_chitiet.so_tien_dinh_muc;
                    item[`S_${sf_hinhthucnopbom.id}`] = sf_bom_chitiet.so_tien_ap_dung;
                    item[`ghi_chu_${sf_hinhthucnopbom.id}`] = sf_bom_chitiet.ghi_chu || "";
                    // Tính tổng tiền
                    item.so_tien += sf_bom_chitiet.so_tien_dinh_muc || 0;
                    item.so_tien_phai_nop += sf_bom_chitiet.so_tien_ap_dung || 0;
                }
            })
            return item;
        })
        return result;
    }, [sf_bom_chitiet_viewmodels, sf_hinhthucnopboms])

    const filtered_raw_data_source = useMemo(() => {
        if (selectedNhomKhoanNopIds.length === 0) return raw_data_source;

        const names =
            selectedNhomKhoanNopNames && selectedNhomKhoanNopNames.length > 0
                ? selectedNhomKhoanNopNames
                : sf_nhomkhoannops
                    ?.filter((x) => selectedNhomKhoanNopIds.includes(x.id))
                    .map((x) => x.nhom_khoan_nop)
                    .filter(Boolean) || [];

        if (names.length === 0) return raw_data_source;

        return raw_data_source.filter((x) => names.includes(x.ten_khoan_nop_group));
    }, [raw_data_source, selectedNhomKhoanNopIds, selectedNhomKhoanNopNames, sf_nhomkhoannops]);

    useEffect(() => {
        const totalAmount = filtered_raw_data_source
            .filter((x) => sf_bom_chitiet_selected_ids.includes(x.id))
            .reduce((count, item) => {
                return count + (item.so_tien_phai_nop || 0);
            }, 0);
        setSummary(totalAmount)
    }, [sf_bom_chitiet_selected_ids, filtered_raw_data_source])

    const handleReloadMucPhaiThuChiTiet = async () => {
        const request = { nam_hoc: localStorageHelper.getNamHoc(), ts_hocsinh_id: props.ts_hocsinh_id }
        const res = await mucPhaiThuChiTietApi.select_all_khoannop(request)
        if (res.is_success) {
            const khoanDaNopIds = res.data.map((x: any) => x.sf_khoannop_id);
            setKhoanDaNops(khoanDaNopIds)
        }
    }

    const handleReloadBom = async () => {
        const res = await bomApi.detail(props.sf_bom_id);
        if (res.is_success) {
            set_sf_bom(res.data)
        }
    }
    const handleReloadBomChiTiets = async () => {
        let isLoading = true;
        const interval_obj = setInterval(() => {
            if (!isLoading) {
                SetIsShowPlaceHolder(false)
                clearInterval(interval_obj);
            }
        }, 500)
        const res = await bomChiTietApi.select(sf_bom?.id || 0);
        if (res.is_success) {
            let data = res.data;
            if (data && props.sf_khoannop_ids_added) {
                data.sf_bom_chitiet_viewmodels = data.sf_bom_chitiet_viewmodels.filter((x: any) =>
                    !props.sf_khoannop_ids_added?.includes(x.sf_khoannop_id));
            }
            const new_sf_bom_chitiets = ConfigSoTienApDung([], data.sf_bom_chitiet_viewmodels);
            set_sf_bom_chitiet_viewmodels(new_sf_bom_chitiets);
        }
        handleReloadMucPhaiThuChiTiet()
        isLoading = false;
    }
    const handleReloadHinhThucNopBom = async () => {
        const res = await hinhThucNopBomApi.select_by_bom(sf_bom?.id || 0);
        if (res.is_success) {
            set_sf_hinhthucnopboms(res.data)
        }
    }
    const ConfigSoTienApDung = (sf_bom_chitiet_selected_ids: number[], _sf_bom_chitiets?: sf_bom_chitiet_viewmodel[]) => {
        if (_sf_bom_chitiets === undefined) _sf_bom_chitiets = sf_bom_chitiet_viewmodels
        const new_sf_bom_chitiets = _sf_bom_chitiets.map(sf_bom_chitiet => {
            if (sf_bom_chitiet_selected_ids.includes(sf_bom_chitiet.sf_khoannop_id)) {
                return { ...sf_bom_chitiet, so_tien_ap_dung: sf_bom_chitiet.so_tien_dinh_muc }
            } else {
                return { ...sf_bom_chitiet, so_tien_ap_dung: 0 }
            }
        })
        return new_sf_bom_chitiets;
    }

    const data_source = useMemo(() => {
        // Group data by ten_khoan_nop_group
        const groupedData: Record<string, any[]> = {};
        filtered_raw_data_source.forEach((item: any) => {
            const groupKey = item.ten_khoan_nop_group || "Khác";
            if (!groupedData[groupKey]) {
                groupedData[groupKey] = [];
            }
            groupedData[groupKey].push(item);
        });

        // Flatten data with group headers
        const result: any[] = [];
        Object.keys(groupedData).forEach((groupKey) => {
            // Add group header row
            result.push({
                id: `group_${groupKey}`,
                isGroupHeader: true,
                ten_khoan_nop_group: groupKey,
                ma_khoan_nop: "",
                ten_khoan_nop: `Nhóm: ${groupKey}`,
                groupItems: groupedData[groupKey],
                isExpanded: expandedGroups.has(groupKey),
            });

            // Chỉ add group items nếu group được expand
            if (expandedGroups.has(groupKey)) {
                groupedData[groupKey].forEach((item) => {
                    result.push({
                        ...item,
                        isGroupHeader: false,
                        parentGroup: groupKey,
                    });
                });
            }
        });

        return result;
    }, [filtered_raw_data_source, expandedGroups]);

    // Tự động expand tất cả groups khi có dữ liệu
    useEffect(() => {
        if (filtered_raw_data_source.length > 0) {
            const newExpandedGroups = new Map<string, string>();
            const uniqueGroups = new Set<string>();
            filtered_raw_data_source.forEach((item) => {
                const groupKey = item.ten_khoan_nop_group || "Khác";
                uniqueGroups.add(groupKey);
            });
            uniqueGroups.forEach((groupKey) => {
                newExpandedGroups.set(groupKey, groupKey);
            });
            setExpandedGroups(newExpandedGroups);
        }
    }, [filtered_raw_data_source]);

    const toggleGroup = useCallback((groupKey: string) => {
        setExpandedGroups((prev) => {
            const newMap = new Map(prev);
            if (newMap.has(groupKey)) {
                newMap.delete(groupKey);
            } else {
                newMap.set(groupKey, groupKey);
            }
            return newMap;
        });
    }, []);

    const handleGroupSelection = useCallback(
        (groupKey: string, isSelected: boolean) => {
            const groupItems = filtered_raw_data_source.filter(
                (item) => (item.ten_khoan_nop_group || "Khác") === groupKey
            );
            const groupItemIds = groupItems.map((item) => item.id);

            if (isSelected) {
                const newSelection = [...sf_bom_chitiet_selected_ids];
                groupItemIds.forEach((id) => {
                    if (!newSelection.includes(id)) {
                        newSelection.push(id);
                    }
                });
                set_sf_bom_chitiet_selected_ids(newSelection);
            } else {
                const newSelection = sf_bom_chitiet_selected_ids.filter(
                    (id) => !groupItemIds.includes(id)
                );
                set_sf_bom_chitiet_selected_ids(newSelection);
            }
        },
        [filtered_raw_data_source, sf_bom_chitiet_selected_ids]
    );

    const handleItemSelection = useCallback(
        (itemId: number, isSelected: boolean) => {
            if (isSelected) {
                if (!sf_bom_chitiet_selected_ids.includes(itemId)) {
                    set_sf_bom_chitiet_selected_ids([
                        ...sf_bom_chitiet_selected_ids,
                        itemId,
                    ]);
                }
            } else {
                set_sf_bom_chitiet_selected_ids(
                    sf_bom_chitiet_selected_ids.filter((id) => id !== itemId)
                );
            }
        },
        [sf_bom_chitiet_selected_ids]
    );

    const handleSoTienChange = useCallback((rowId: number, hinhThucNopBomId: number, value: number) => {
        if (sf_bom_chitiet_selected_ids.includes(rowId)) {
            const new_sf_bom_chitiets = sf_bom_chitiet_viewmodels.map(x => {
                if (x.sf_khoannop_id === rowId && x.sf_hinhthucnopbom_id === hinhThucNopBomId) {
                    return { ...x, so_tien_ap_dung: value }
                } else {
                    return { ...x }
                }
            })
            set_sf_bom_chitiet_viewmodels(new_sf_bom_chitiets)
        } else {
            showNotify({ message: "Vui lòng chọn khoản nộp trước", type: "warning" })
        }
    }, [sf_bom_chitiet_selected_ids, sf_bom_chitiet_viewmodels])

    const handleGhiChuChange = useCallback((rowId: number, hinhThucNopBomId: number, value: string) => {
        const new_sf_bom_chitiets = sf_bom_chitiet_viewmodels.map(x => {
            if (x.sf_khoannop_id === rowId && x.sf_hinhthucnopbom_id === hinhThucNopBomId) {
                return { ...x, ghi_chu: value }
            } else {
                return { ...x }
            }
        })
        set_sf_bom_chitiet_viewmodels(new_sf_bom_chitiets)
    }, [sf_bom_chitiet_viewmodels])

    const handelSubmit = () => {
        const data = {
            sf_bom_id: sf_bom?.id || 0,
            is_calculate_miengiam: is_tinh_mien_giam,
            sf_bom_chitiets: sf_bom_chitiet_viewmodels.filter(x => sf_bom_chitiet_selected_ids.includes(x.sf_khoannop_id)),
            sf_hinhthucnopbom_id: 0
        }
        props.onSelected(data);
    }

    const columns = useMemo<IDataGridColumn[]>(() => {
        const result: IDataGridColumn[] = [
            {
                caption: "Tên khoản nộp",
                id: "ten_khoan_nop",
                dataField: "ten_khoan_nop",
                width: 250,
                align: "left",
                fixed: "left",
                cellRender: (data: any) => {
                    const isExpanded = expandedGroups.has(data.ten_khoan_nop_group || "Khác");
                    const level = data.isGroupHeader ? 0 : 1;
                    const isGroup = data.isGroupHeader;

                    if (isGroup) {
                        const groupKey = data.ten_khoan_nop_group || "Khác";
                        const groupItems = filtered_raw_data_source.filter(
                            (item) => (item.ten_khoan_nop_group || "Khác") === groupKey
                        );
                        const groupItemIds = groupItems.map((item) => item.id);
                        const isAllSelected =
                            groupItemIds.length > 0 &&
                            groupItemIds.every((id) =>
                                sf_bom_chitiet_selected_ids.includes(id)
                            );
                        const isPartialSelected = groupItemIds.some((id) =>
                            sf_bom_chitiet_selected_ids.includes(id)
                        );

                        return (
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                                <Box sx={{ width: `${level * 30}px` }}>&nbsp;</Box>
                                <IconButton
                                    icon={!isExpanded ? ChevronRightIcon : ChevronUpIcon}
                                    aria-label=""
                                    variant="invisible"
                                    size="small"
                                    onClick={() => toggleGroup(groupKey)}
                                />
                                <Checkbox
                                    checked={isAllSelected}
                                    indeterminate={isPartialSelected && !isAllSelected}
                                    onChange={(e) =>
                                        handleGroupSelection(groupKey, e.target.checked)
                                    }
                                />
                                <Box
                                    sx={{
                                        fontSize: "13px",
                                        fontWeight: "bold",
                                        marginLeft: "8px",
                                        color: "#0969da",
                                    }}
                                >
                                    Nhóm: {groupKey}
                                </Box>
                            </Box>
                        );
                    } else {
                        return (
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                                <Box sx={{ width: `${level * 30}px` }}>&nbsp;</Box>
                                <Checkbox
                                    checked={sf_bom_chitiet_selected_ids.includes(data.id)}
                                    onChange={(e) =>
                                        handleItemSelection(data.id, e.target.checked)
                                    }
                                />
                                <Box sx={{ marginLeft: "8px" }}>
                                    <TextWithEllipse
                                        text={data.ten_khoan_nop || ""}
                                        lineNumber={2}
                                    />
                                </Box>
                            </Box>
                        );
                    }
                },
            },
            {
                caption: "Mã",
                id: "ma_khoan_nop",
                dataField: "ma_khoan_nop",
                width: 100,
                align: "left",
                fixed: "left",
                cellRender: (data: any) => {
                    if (data.isGroupHeader) {
                        return <span></span>;
                    }
                    return <TextWithEllipse text={data.ma_khoan_nop || ""} lineNumber={1} />;
                },
            },
        ];

        // Thêm cột định mức cho mỗi hình thức nộp bom
        if (sf_hinhthucnopboms.length > 0) {
            result.push({
                caption: "Định mức",
                id: "dinh_muc",
                align: "center",
                columns: sf_hinhthucnopboms.map((x) => ({
                    caption: x.name,
                    id: `T_${x.id}`,
                    dataField: `T_${x.id}`,
                    width: 120,
                    align: "right" as const,
                    isAllowFocus: false,
                    cellRender: (data: any) => {
                        if (data.isGroupHeader) {
                            return <span></span>;
                        }
                        const value = data[`T_${x.id}`] || 0;
                        return (
                            <div style={{ textAlign: "right" }}>
                                {formatVND(value)}
                            </div>
                        );
                    },
                })),
            });

            // Thêm cột số tiền phải nộp (có thể edit)
            result.push({
                caption: "Số tiền phải nộp",
                id: "so_tien_phai_nop",
                align: "center",
                columns: sf_hinhthucnopboms.map((x) => ({
                    caption: "Số tiền",
                    id: `S_${x.id}`,
                    dataField: `S_${x.id}`,
                    width: 150,
                    align: "right" as const,
                    isAllowFocus: true,
                    cellRender: (data: any) => {
                        if (data.isGroupHeader) {
                            return <span></span>;
                        }
                        const value = data[`S_${x.id}`] || 0;
                        const isSelected = sf_bom_chitiet_selected_ids.includes(data.id);
                        return (
                            <Box sx={{ width: "100%", display: "flex", justifyContent: "flex-end" }}>
                                <NumberBox
                                    value={value}
                                    format="#,##0"
                                    width="100%"
                                    stylingMode="outlined"
                                    disabled={!isSelected}
                                    onValueChanged={(e) => {
                                        if (e.value !== null && e.value !== undefined) {
                                            handleSoTienChange(data.id, x.id, e.value);
                                        }
                                    }}
                                />
                            </Box>
                        );
                    },
                })),
            });

            // Thêm cột ghi chú (có thể edit)
            result.push({
                caption: "Ghi chú",
                id: "ghi_chu",
                align: "center",
                columns: sf_hinhthucnopboms.map((x) => ({
                    caption: "Ghi chú",
                    id: `ghi_chu_${x.id}`,
                    dataField: `ghi_chu_${x.id}`,
                    width: 200,
                    align: "left" as const,
                    isAllowFocus: true,
                    cellRender: (data: any) => {
                        if (data.isGroupHeader) {
                            return <span></span>;
                        }
                        const value = data[`ghi_chu_${x.id}`] || "";
                        return (
                            <Box sx={{ width: "100%" }}>
                                <TextInput
                                    value={value}
                                    onChange={(e) => {
                                        handleGhiChuChange(data.id, x.id, e.target.value);
                                    }}
                                    sx={{ width: "100%" }}
                                />
                            </Box>
                        );
                    },
                })),
            });
        }

        return result;
    }, [
        sf_hinhthucnopboms,
        expandedGroups,
        sf_bom_chitiet_selected_ids,
        filtered_raw_data_source,
        toggleGroup,
        handleGroupSelection,
        handleItemSelection,
        handleSoTienChange,
        handleGhiChuChange,
    ]);

    return (
        <div>
            <div className="pop-up-form">
                <ScrollView width={"100%"} height={window.innerHeight - 170}>
                    <div>
                        {isShowPlaceHolder && <PlaceHolder line_number={20} />}
                        {!isShowPlaceHolder && (
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-inline" style={{ paddingLeft: "1rem" }}>
                                        <div className="form-group" style={{ flex: 1 }}>
                                            <div style={{
                                                fontWeight: "bold",
                                                fontSize: "1.1rem",
                                                whiteSpace: "pre-line"
                                            }}>
                                                {sf_bom?.ten_bom || ""}
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label className='form-label'>Tổng tiền phải nộp: {summary?.toLocaleString()} </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <DataGrid
                                        title={
                                            <Text
                                                text="Danh sách khoản nộp"
                                                sx={{ fontSize: 16, fontWeight: 600 }}
                                            />
                                        }
                                        actionComponent={
                                            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                                                <Box sx={{ width: 220 }}>
                                                    <SelectBoxMultipleKhomKhoanNop
                                                        width="100%"
                                                        size="small"
                                                        isShowClearBtn
                                                        value={selectedNhomKhoanNopIds}
                                                        onValueChanged={(ids) => {
                                                            const safeIds = ids || [];
                                                            setSelectedNhomKhoanNopIds(safeIds);
                                                            const names =
                                                                sf_nhomkhoannops
                                                                    ?.filter((x) => safeIds.includes(x.id))
                                                                    .map((x) => x.nhom_khoan_nop)
                                                                    .filter(Boolean) || [];
                                                            setSelectedNhomKhoanNopNames(names as string[]);
                                                        }}
                                                    />
                                                </Box>
                                            </Box>
                                        }
                                        dataSource={data_source}
                                        height={window.innerHeight - 250}
                                        columns={columns}
                                        isShowRowIdx={false}
                                        paging={{
                                            enable: false,
                                        }}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                </ScrollView>
            </div>
            <ModalActions>
                <Button
                    variant="default"
                    leadingVisual={XIcon}
                    text="Đóng"
                    onClick={() => { props.onCancel() }}
                />
                <Button
                    variant="primary"
                    leadingVisual={CheckIcon}
                    text="Bổ sung"
                    isLoading={props.isSaving}
                    disabled={sf_bom_chitiet_selected_ids.length === 0}
                    onClick={handelSubmit}
                />
            </ModalActions>
        </div>
    );
}
